import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import messages from '../registrationMessages';
import intlShape from '@/shared/utils/intlShape';

const addMinutesChange = (duration, minutes) => duration + minutes;
const roundMinutesChange = (duration, minutes) => Math.round(duration / minutes, 10) * minutes;
const TimeButtons = ({
  addMinutes = [],
  roundMinutes = [],
  value,
  onChange,
  className,
  buttonClassName,
  disabled,
  intl,
}) => (
  <div className={classNames('time-buttons', className)}>
    {addMinutes && addMinutes.length > 0
      ? addMinutes.map(x => {
          const id = `Add${x}Button`;

          return (
            <button
              type="button"
              key={id}
              id={id}
              className={classNames('btn', buttonClassName)}
              disabled={disabled}
              onClick={() => {
                onChange(addMinutesChange(value, x));
                document.activeElement.blur();
              }}
              title={intl.formatMessage(messages.AddMinutes, { minutes: x })}
            >
              <span>&nbsp;+{x}&apos;&nbsp;</span>
            </button>
          );
        })
      : null}
    {roundMinutes && roundMinutes.length > 0
      ? roundMinutes.map(x => {
          const id = `Round${x}Button`;

          return (
            <button
              type="button"
              key={id}
              id={id}
              className={classNames('btn', buttonClassName)}
              disabled={disabled}
              onClick={() => {
                onChange(roundMinutesChange(value, x));
                document.activeElement.blur();
              }}
              title={intl.formatMessage(messages.RoundToNearestX, { minutes: x })}
            >
              <span>&nbsp;|{x}|&nbsp;</span>
            </button>
          );
        })
      : null}
  </div>
);
TimeButtons.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  addMinutes: PropTypes.arrayOf(PropTypes.number),
  roundMinutes: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
};
TimeButtons.defaultProps = {
  value: 0,
  disabled: false,
  addMinutes: [5, 10, 15],
  roundMinutes: [5, 10, 15],
  className: 'time-buttons-sm',
  buttonClassName: 'btn-xs btn-inverse',
};
export default TimeButtons;
